import { register } from "ol/proj/proj4";
import proj4 from "proj4";

// Drzavni koordinatni sistem katastra RS (MGI 1901 / Balkans zone 6)
proj4.defs(
  "EPSG:8678",
  "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=6500000 +y_0=0 +ellps=bessel " +
    "+towgs84=682,-203,480,0,0,0,0 +units=m +no_defs +type=crs",
);
register(proj4);

export const NATIVE = "EPSG:8678";
